import React from "react";
import styled from "styled-components";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { InitialStateType } from "../types";
import { useIntl } from "react-intl";
import { wizardMessages } from "../messages";
import { Icon } from "@fluentui/react";

type AuditMonitoringProps = {
  state: InitialStateType;
  isHosted: boolean;
  dispatch: (data: any) => void;
};

const AuditMonitoring = ({ state, isHosted, dispatch }: AuditMonitoringProps) => {
  const intl = useIntl();
  const { enableAudit, disableSystem } = state?.creationForm;

  return (
    <Wrapper>
      <Record>
        <Toggle
          defaultChecked={enableAudit}
          id="Enable audit"
          inlineLabel
          label={<Tooltip>{intl.formatMessage(wizardMessages.auditSwitch)} &nbsp;</Tooltip>}
          onChange={(_, checked) => {
            dispatch({
              type: "update",
              payload: {
                form: "creationForm",
                data: {
                  enableAudit: checked,
                },
              },
            });
          }}
        />
      </Record>
      {!isHosted && (
        <Record>
          <Toggle
            inlineLabel
            defaultChecked={!disableSystem}
            label={
              <Tooltip>
                {intl.formatMessage(wizardMessages.collectionSwitch)} &nbsp;
                <IconWithTooltip tooltipText={intl.formatMessage(wizardMessages.jobsTitleToggle)} />
              </Tooltip>
            }
            id="Enable change collection jobs"
            onChange={(_, checked) => {
              dispatch({
                type: "update",
                payload: {
                  form: "creationForm",
                  data: {
                    disableSystem: !checked,
                  },
                },
              });
            }}
          />
        </Record>
      )}
    </Wrapper>
  );
};

const IconWithTooltip = ({ tooltipText }: { tooltipText: string }) => (
  <>
    <TooltipHost content={`${tooltipText}`} id={tooltipText}>
      <Icon iconName={"Info"} aria-describedby={tooltipText} />
    </TooltipHost>
  </>
);

const Tooltip = styled.div`
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Record = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-weight: 500;
`;

export default AuditMonitoring;
